import { render, staticRenderFns } from "./LinkMaisInfTable.vue?vue&type=template&id=36d8ca5a&scoped=true&"
import script from "./LinkMaisInfTable.vue?vue&type=script&lang=js&"
export * from "./LinkMaisInfTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d8ca5a",
  null
  
)

export default component.exports